import { useContext, useState } from 'react'
import { CartContext } from 'contexts/CartContext'
import { LoadingContext } from 'contexts/LoadingContext'
import { Item } from 'hooks/useProduct'
import { BatchColorFailedItem } from 'hooks/useCart'

export const useBatchColorEdit = (
  items: Item[],
  cartId: string,
  isQuote = false
) => {
  const { batchUpdateColor } = useContext(CartContext)
  const { showLoading, stopLoading } = useContext(LoadingContext)

  const [isBatchEditing, setIsBatchEditing] = useState(false)
  const [selectedItems, setSelectedItems] = useState<string[]>([])
  const [notFoundItems, setNotFoundItems] = useState<BatchColorFailedItem[]>([])
  const [outOfStockItems, setOutOfStockItems] = useState<
    BatchColorFailedItem[]
  >([])

  const isAllSelected =
    items.length > 0 && selectedItems.length === items.length

  const selectItem = (cartItemId: string, isSelected: boolean) => {
    setSelectedItems(prev =>
      isSelected ? [...prev, cartItemId] : prev.filter(id => id !== cartItemId)
    )
  }

  const toggleSelectAll = () => {
    setSelectedItems(isAllSelected ? [] : items.map(item => item.cartItemId))
  }

  const openBatchEdit = () => setIsBatchEditing(true)

  const closeBatchEdit = () => {
    setIsBatchEditing(false)
    setNotFoundItems([])
    setOutOfStockItems([])
  }

  const runBatchUpdate = async (skuPrefix: string) => {
    const itemsToUpdate = items.filter(item =>
      selectedItems.includes(item.cartItemId)
    )
    showLoading()
    try {
      const result = await batchUpdateColor(
        skuPrefix,
        itemsToUpdate,
        cartId,
        isQuote
      )
      if (!result) {
        return
      }

      const { notFound, outOfStock } = result
      setNotFoundItems(notFound)
      setOutOfStockItems(outOfStock)
      setSelectedItems([])
      if (notFound.length === 0 && outOfStock.length === 0) {
        setIsBatchEditing(false)
      }
    } finally {
      stopLoading()
    }
  }

  return {
    isBatchEditing,
    selectedItems,
    notFoundItems,
    outOfStockItems,
    isAllSelected,
    selectItem,
    toggleSelectAll,
    openBatchEdit,
    closeBatchEdit,
    runBatchUpdate
  }
}
